import { combineReducers } from 'redux';

import confirmaPreCadastroRenovacao from './confirmaPreCadastroRenovacao/reducer';
import gerarRenach from './gerarRenach/reducer';

export default combineReducers({
	confirmaPreCadastroRenovacao,
	gerarRenach,
});
